import { useContext } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { isEmpty } from 'ramda'
import { ActiveEnterpriseContext } from '../../../context/activeEnterpriseContext'
import ChevronLeftIcon from '../../../icons/chevronLeftIcon'

const ReturnLink = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    // Add clear_delegation param to signal WordPress to clear cookies and cache
    window.location.href = `${process.env.REACT_APP_ACQ_SITE as string}?clear_delegation=1`
  }

  return (
    <Box
      component='a'
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'primary.main',
        cursor: 'pointer',
        paddingBottom: '16px',
        marginLeft: '4px'
      }}
      href={`${process.env.REACT_APP_ACQ_SITE as string}?clear_delegation=1`}
      onClick={handleClick}
    >
      <ChevronLeftIcon />
      <Typography variant='h6' ml='6px' sx={{ paddingBottom: '2px' }}>
        Retour au site ACQ
      </Typography>
    </Box>
  )
}

export default ReturnLink
